<script>
import apiHelper from "@/mixins/apiHelper.js";

export default {
  mixins: [
    apiHelper,
  ],
  props: {
    folderId: {
      type: String,
      required: false,
    },
  },
  emits: ['editSuccess'],
  data() {
    return {
      dialog: false,
      folder_id: null,
      values: {
        name: '',
        shared: false,
      },
      errors: {
        name: false,
      },
    }
  },
  methods: {
    openDialog(data) {
      // Set default value to the current name
      this.values.name = data.name;
      this.values.shared = data.shared;
      this.folder_id = data.id;
      // Open dialog
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async editFolder() {
      if (this.values.name === '') {
        this.errors.name = true;
        return;
      }

      let payload = {
        name: this.values.name,
        shared: this.values.shared,
      };
      // Send request to API
      const response = await fetch('/api/file-folder/' + this.folder_id, {
        method: 'PATCH',
        credentials: "include", // Set to make sure the cookies are send with the request.
        headers: this.requestHeaders,
        body: JSON.stringify(payload)
      });

      const status_code = response.status;

      if (status_code === 200) {
        // Emit event
        this.$emit('editSuccess');
        // Close dialog
        this.closeDialog();
        // Show success message
        this.$toast.add({ severity: 'success', summary: 'Geslaagd', detail: 'De map is aangepast.', group: 'global', life: 3000 });
        return true;
      }

      // Show success message
      this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'De map kon niet aangepast worden.', group: 'errors' });
    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />
  <Toast position="top-center" group="errors" />

  <Dialog v-model:visible="dialog" modal header="Map aanpassen" :style="{ width: '32rem' }">

    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <label for="name">Naam *</label>
        <InputText id="name" v-model="values.name" autocomplete="off" :invalid="errors.name" @input="errors.name = false" />
        <Message v-if="errors.name" severity="error">Naam is verplicht</Message>
      </div>
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2 mt-2">
          <ToggleSwitch v-model="values.shared" inputId="shared" />
          <label for="shared">Gedeelde map</label>
        </div>
        <p class="text-gray-500">Gedeelde mappen zijn zichtbaar voor alle gebruikers.</p>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-3">
      <Button type="button" label="Annuleren" severity="secondary" @click="closeDialog"></Button>
      <Button type="button" label="Opslaan" @click="editFolder"></Button>
    </div>

  </Dialog>

</template>

<style>

</style>
